<template>
  <div class="BrickItem" @click="toggleCheck">

    <div class="item" :class="{'check': item.checked, 'bingo': item.bingo}" :style="{'animation-delay': delay+'s'}">
      <emoji class="emoji">
        {{item.item.emoji}}
      </emoji>
      <div class="text">
        {{item.item.text}}
      </div>
    </div>

  </div>
</template>

<script>

import { store } from '@/store';

import Emoji from '@/components/Emoji'

export default {
  name: 'BrickItem',
  components: {
    Emoji
  },
  data () {
    return {
      delay: ""
    }
  },
  props: {
    item: ""
  },
  computed: {
    bingo: function () {
      return store.state.bingo;
    }
  },
  watch: {
  },
  methods: {
    toggleCheck: function () {

      let params = {
        item: this.item,
      }

      store.commit('toggleBrickItem',params);
    },
  },
  mounted: function () {
    this.delay = Math.random();
  },
  updated: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.item{
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  position: relative;
  transition: all 0.5s ease-out;
  cursor: pointer;
  background: white;
  overflow: hidden;
}

.item.check{
  background-image: linear-gradient(to bottom right, palegreen, yellow);
}

.emoji{
  flex: 0 1 75%;
  font-size: 50pt;
  transition: all 0.5s linear;
}

.text{
  flex: 1 0 25%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  transition: all 0.1s;
  font-size: 0.8em;
  background: rgba(255,255,255,0.75);
  font-weight: 600;
  text-align: center;
}

.check.bingo {
  background: palegreen;
  animation: party 1.5s infinite;
}

@media screen and (min-width: 600px) {

  .check{
    transform: rotateY(360deg);
  }

  .emoji{
    /*filter: saturate(1) blur(10px);*/
    transition: all 0.5s ease-out;
    font-size: 100pt;
    margin: 20px;
  }

  .check .emoji {
    filter: blur(0px);
  }

  .item:hover .text{
    transform: scale(1.2) rotateZ(-2deg);
  }

  .text{
    font-size: 1em;
  }

}

@keyframes party {
  50% {
    background: lightblue;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/BrickItem.vue